import GpayImage from './gpay.png';

const TransactionMethodTransformer = (type, metadata = {}) => {
  if (metadata?.apm) {
    return {
      image: GpayImage,
      imageClass: 'w-[45px] m-auto',
      label: 'Google Pay',
    }
  }

  if (type === 'MOTO_OTHER' || type === 'MOTO_IN_PERSON') {
    return {
      icon: 'ni-user',
      label: 'Moto',
    };
  }

  if (type === 'TOKENISED') {
    return {
      icon: 'ni-save',
      label: 'Vaulted ',
    }
  }

  if (type === 'BANK') {
    return {
      icon: 'ni-building',
      label: 'Bank transfer',
    }
  }

  if (type === 'ONLINE') {
    return {
      icon: 'ni-browser',
      label: 'Online',
    }
  }

  return {
    icon: 'ni-question',
    label: type
  };
}

export default TransactionMethodTransformer;
